<template>
    <div class="content-wrapper">
        <app-page-top-section :title="$t('reward_settings')"/>
        <app-tab
            :tabs="tabs"
            icon="settings"
        />
    </div>
</template>

<script>
export default {
    name: "RewardSettingLayout",
    data() {
        return {
            tabs: [
                {
                    name: this.$t('tick-in points'),
                    title: this.$t('tick-in points'),
                    component: "app-tick-in-settings",
                    permission: Boolean(this.$can('view_reward_settings'))
                },
            ]
        }
    }
}
</script>

<style scoped>

</style>